import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface FormSectionProps {
  icon: LucideIcon;
  title: string;
  /** Right-aligned hint text in the section header (e.g. "opcjonalne"). */
  hint?: string;
  children: React.ReactNode;
  className?: string;
}

/** Card-style form section with an icon + uppercase heading. */
export function FormSection({ icon: Icon, title, hint, children, className }: FormSectionProps) {
  return (
    <div className={cn("rounded-xl border border-black/5 bg-pulso-surface p-5", className)}>
      <h3 className="mb-3.5 flex items-center gap-2 text-[13px] font-bold uppercase tracking-[0.06em] text-pulso-muted">
        <Icon className="h-3.5 w-3.5" />
        {title}
        {hint && (
          <span className="ml-auto text-xs font-medium normal-case tracking-normal text-pulso-muted/70">
            {hint}
          </span>
        )}
      </h3>
      {children}
    </div>
  );
}
